import React, { useState,useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import AdminWrapper from "../Admin/AdminWrapper";
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar";
import StatisticsTable, { avaTable } from "./statisticsTable";
import {availableTable,statTable,newRegTable} from "./statisticsTable";
import { StylesStatistics } from "./styled";
import StatisticsBarChart from "./Charts/barChart";
import {bookingReportBarChart,bookingBarChart, topTen} from './Charts/barChart';
import {
  Weekend,
  Refresh,
  Leaderboard,
  Store,
  PersonAdd,
  School,
  AccountBox,
  Assignment
} from "@mui/icons-material";
import StatisticsPieChart from "./Charts/pieChart";
import {userPie} from "./Charts/pieChart";
import StatisticsLineChart from "./Charts/lineChart";
import {bookingLineChart} from "./Charts/lineChart";
import useStatistics from "./hook";
import { useHistory } from 'react-router-dom';

const StatistisHeaderCard = ({ icon, name, value, className, detail }) => {
  const [loading, setIsLoading] = useState(false);
  const handleRefresh = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 3000);
  };
  return (
    <div className="col statistic-card card-transform">
      <div className="statistic-card--header">
        <div className={`statistic-card--icon ${className}`}>{icon}</div>
        <div className="d-flex flex-col" style={{ paddingTop: '20px' }}>
          {/* <p className="text-sm">{name}</p> */}
          <p className="font-bold text-xl">{name + ': ' + value}</p>
          <p className="text-sm">{detail}</p>
        </div>
      </div>
      <hr class="dark_horizontal my-0"></hr>
      {/* <div
        className={`statistic-card--footer cursor-pointer flex items-center ${
          loading && "loading"
        }`}
      >
        <Refresh onClick={handleRefresh} sx={{ color: "#5f5c5c" }} />
        <p className="ml-2">{loading ? "Updating" : "Update now"}</p>
      </div> */}
    </div>
  );
};

const StatisticsPageLayout = ({
  states,
  customers,
  barChartLabels,
  bookingReport,
  bookingStateReport,
  bookingStateReportHrs,
  bookingReportKeys,
  bookingReportOptions,
  bookingReportMonths,
  userAll,
  userPieData,
  userItemOption,
  userStateOption,
  morningET,
  autoAllocate,
  etPie,
  etPieOpt,
  etPieOptions,
  handleChangeBarchartStates,
  handleChangeUserPie,
  handleChangeUserPieState,
  handleChangeETPie,
  handleChangeBookingReportMont,
  handleChangeETReportMont,
  bookingBarData,
  bookingBarOpt,
  unassigned,
  unassignedState,
  avaTeacher,
  avaTeacherState,
  todayTable,
  activeStateC,
  activeStateT,
  activeData,
  statesC,
  statesT,
  changeTopTenStateC,
  changeTopTenStateT,
  changeTopTenMonth,
  handleChangeReport,
  newReg,
  newRegView,
  newRegTView,
  newRegWeek,
  newRegType,
  updateCheckbox,
  handleChangeState,
}) => {
  const history = useHistory();
  const relocate = () =>{
  history.push('/allocateET')
  }
  const [loading, setLoading] = useState(true);
const [bookhistory, setBookHistory] = useState(bookingStateReport);
useEffect(() => {
  // Check if bookingStateReport is available
  if (bookingStateReport) {
    // Set bookhistory and update loading state
    setBookHistory(bookingStateReport);
    setLoading(false);
  }
}, [bookingStateReport]);
  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <StylesStatistics>
        <h1 className="text-3xl font-bold text-center">Admin Dashboard</h1>
        <div className="row">
          <div className="col flex flex-col items-center justify-between statistic-card">
          <div className="row">
            <div
            onClick={unassigned > 0 ? relocate : null}
            style={{ cursor: unassigned > 0 ? 'pointer' : 'default' }}
            >
          <StatistisHeaderCard
            name="New Bookings"
            value= {unassigned}
            detail = {unassignedState}
            icon={<Assignment sx={{ color: "#fff" }} />}
            className={unassigned > 0 ? "bg-gradient-info" : 'bg-gradient-dark'}
          />
          </div>
          </div>
          {/* <h3 className="mb-4">Available Teachers</h3> */}
          {/* <div className="row">
          <StatistisHeaderCard
            name="Available Teachers"
            value={avaTeacher}
            // detail={avaTeacherState}
            icon={<AccountBox sx={{ color: "#fff" }} />}
            className="bg-gradient-success"
          />
          </div> */}
          <div className="row">
          <div className="col statistic-card items-center">
            {availableTable(avaTeacherState)}
          </div>
          </div>
        </div>
          <div className="col flex flex-col items-center justify-between statistic-card">
          <h3 className="mb-4">Today Overview</h3>
          
          <div className="row">
          <div className="col statistic-card">
            {statTable(todayTable)}
          </div>
          </div>
        </div>
        </div>
        <div className="row">
        <div className="col flex flex-col items-center justify-between statistic-card">
            <h3 className="mb-4">Booking History</h3>
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={['Count','Hours']}
                onChange={(e,value)=>{
                  setBookHistory(value === 'Count' ? bookingStateReport : bookingStateReportHrs)
                }}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="View" />
                )}
              />
            {loading ? (
              <p>Loading...</p>
            ) : (
              bookingLineChart(bookhistory)
            )}
          </div>
        {/* <div className="col flex flex-col items-center justify-between statistic-card">
            <h3 className="mb-4">Booking History</h3>
            <StatistisHeaderCard
            name="new Bookings"
            value= {unassigned}
            detail = {unassignedState}
            icon={<Assignment sx={{ color: "#fff" }} />}
            className="bg-gradient-info"
          />
          </div> */}
          </div>
        <div className="row">
          <div className="col flex flex-col items-center justify-between statistic-card">
          <h3 className="mb-4">New Registrations this week</h3>
          <div className="col statistic-card">
          <div className="flex items-center mb-4">
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={['1 Week Ago','2 Weeks Ago','3 Weeks Ago','4+ Weeks Ago']}
                onChange={(e,value)=>{newRegWeek(value)}}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Week" />
                )}
              />
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={[,'ELICOS','VET','ELICOS/VET','ECEC']}
                onChange={(e,value)=>{newRegType(value)}}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Type" />
                )}
              />
          </div>
              {newRegTable(newRegView,updateCheckbox,newRegTView)}
          </div>
        </div>
        </div>
        <div className="row">
          <div className="col statistic-card">
            <h3 className="mb-4 text-center">
              Top Ten Customers
            </h3>
            <div className="flex items-center mb-4">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={bookingReportMonths}
                onChange={changeTopTenMonth}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Month" />
                )}
              />
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={statesC}
                onChange={changeTopTenStateC} 
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="State" />
                )}
              />
            </div>
            {topTen(activeData,activeStateC,'customer')}
          </div>
          <div className="col statistic-card">
            <h3 className="mb-4 text-center">
              Top Ten Teachers
            </h3>
            <div className="flex items-center mb-4">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={statesT}
                onChange={changeTopTenStateT}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="State" value={activeStateT}/>
                )}
              />
            </div>
            {topTen(activeData,activeStateT,'teacher')}
          </div>
          
        </div>
        <div className="row">
          <div className="col statistic-card">
            <h3 className="mb-4 text-center">
              Booking Report
            </h3>
            <div className="flex items-center mb-4">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={bookingReportMonths}
                onChange={handleChangeBookingReportMont}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Month" />
                )}
              />
              {/* <Autocomplete
                disablePortal
                multiple
                id="combo-box-demo"
                options={Object.keys(bookingReport)}
                onChange={handleChangeBarchartStates}
                sx={{ minWidth: 200 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="State" />
                )}
              /> */}
            </div>
            {bookingReportBarChart(bookingReport)}
          </div>
          <div className="col flex flex-col items-center statistic-card">
            <h3 className="mb-4">{etPieOpt}</h3>
            <div className="flex items-center mb-4">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={bookingReportMonths}
                onChange={handleChangeETReportMont}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Month" />
                )}
              />
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={etPieOptions}
                onChange={handleChangeETPie}
                sx={{ minWidth: 200 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label={etPieOpt} />
                )}
              />
            </div>
            {userPie(etPie, etPieOpt)}
          </div>
        </div>
        <div className="row">
        <div className="col statistic-card">
            <h3 className="mb-4 text-center">
            Active Teachers and Customers
            </h3>
            <div className="flex items-center mb-4">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={bookingReportMonths}
                onChange={handleChangeBookingReportMont}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Month" />
                )}
              />
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={bookingReportOptions}
                onChange={handleChangeReport}
                sx={{ minWidth: 200 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Report" placeholder={bookingBarOpt} />
                )}
              />
              {/* <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={Object.keys(bookingReport)}
                onChange={handleChangeState}
                sx={{ minWidth: 200 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="State" />
                )}
              /> */}
            </div>
            {bookingBarChart(bookingBarData,bookingBarOpt)}
          </div>
          <div className="col flex flex-col items-center statistic-card">
            <h3 className="mb-4">Teachers by Criteria</h3>
            <div className="flex items-center mb-4">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={userStateOption}
                onChange={handleChangeUserPieState}
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="State" />
                )}
              />
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={userItemOption}
                onChange={handleChangeUserPie}
                sx={{ minWidth: 200 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label={userPieData} />
                )}
              />
            </div>
            {userPie(userAll, userPieData)}
            {/* <StatisticsPieChart /> */}
          </div>
        </div>
        <div className="row">
         
        </div>
        {/* <div className="row">
          <div className="col statistic-card">
            <StatisticsTable name="Bookings" />
          </div>
          <div className="col statistic-card">
            <StatisticsTable name="Job Listing Applications" />
          </div>
        </div>
        <div className="row">
          <div className="col statistic-card">
            <h3 className="mb-4 text-center">
              Customer spend last month vs this month
            </h3>
            <div className="flex items-center mb-4">
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={customers}
                // getOptionLabel={(option) =>
                //   option?.institution_id?.institution_name
                // }
                sx={{ minWidth: 200, marginRight: "12px" }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Name" />
                )}
              />
              <Autocomplete
                disablePortal
                multiple
                id="combo-box-demo"
                options={states}
                onChange={handleChangeBarchartStates}
                sx={{ minWidth: 200 }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="State" />
                )}
              />
            </div>
            <StatisticsBarChart barChartLabels={barChartLabels} />
          </div>
          <div className="col flex flex-col items-center justify-between statistic-card">
            <h3 className="mb-4">Hours per location</h3>
            <StatisticsLineChart />
          </div>
        </div> */}
      </StylesStatistics>
    </AdminWrapper>
  );
};

const StatisticsPage = (props) => {
  return <StatisticsPageLayout {...useStatistics(props)} />;
};
export default StatisticsPage;
